import Blue from "~/dfwjobs/core";

new Blue({
	name: 'Search Modal',
	selector: ".search-modal",
	setup(modal) {
		const trigger = document.querySelector(".header__search-trigger");
		const searchIcon = trigger.querySelector("i");
		const alert = document.querySelector(".alert");
		const header = document.querySelector("header.header");
		const mobileNavTrigger = document.querySelector("button.header__mobile-trigger");
		const input = modal.querySelector(".search-modal__input");
		const inputContainer = modal.querySelector(".search-modal__input-container");
		const overlay = modal.querySelector(".search-modal__overlay");
		const submit = modal.querySelector(".search-modal__submit");
		const close = modal.querySelector(".search-modal__close");
		let isModalOpen = false;

		const openModal = () => {
			let that = this;
			modal.classList.add("modal-active");
			isModalOpen = true;
			that.$scrollLock.lock(document.body);
			if (window.innerWidth < 767) {
				searchIcon.classList.remove("blue-icon-search");
				searchIcon.classList.add("blue-icon-close");
				modal.style.marginTop = alert.offsetHeight + header.offsetHeight + "px";
			}
			input.focus();
		} 
		const closeModal = () => {
			let that = this;
			modal.classList.remove("modal-active");
			isModalOpen = false;
			that.$scrollLock.unlock(document.body);
			if (window.innerWidth < 767) {
				searchIcon.classList.remove("blue-icon-close");
				searchIcon.classList.add("blue-icon-search");
			}
			trigger.focus();
		}

		const submitSearch = (event) => {
			event.preventDefault();
			let queryString = input.value == "" ? "" : "?query=" + encodeURIComponent(input.value);
			let searchPage = input.getAttribute("data-submit-page") || "search";
			let newUrl = location.origin;

			location.href = newUrl + "/" + searchPage + queryString;
		}

		this.$addEvents(trigger, 'click', () => {
			if (searchIcon.matches(".blue-icon-close")) {
				closeModal();
			} else {
				openModal();
			}
		});
		this.$addEvents(close, 'click', () => {
			closeModal();
		});
		this.$addEvents(mobileNavTrigger, 'click', () => {
			closeModal();
		});
		this.$addEvents(document.body, 'escape', () => {
			closeModal();
		});
		this.$addEvents(overlay, 'click', (e) => {
			closeModal();
		});
		this.$addEvents(inputContainer, 'click.stop', (e) => {});
		this.$addEvents(submit, 'click', (e) => {submitSearch(e)});
		this.$addEvents(submit, 'tab tab.shift.prevent', () => {
			close.focus();
		});
		this.$addEvents(close, 'tab tab.shift', () => {
			input.focus();
		});
		this.$addEvents(document.body, 'keydown', (e) => {
			if(isModalOpen && e.keyCode === 13) {
				submitSearch(e);
			}
		});
  }
});
